"use client";

import { FC } from "react";

interface DematButtonProps {
  ButtonText?: string;
  onClick?: () => void;
}

const InvestButton: FC<DematButtonProps> = ({ ButtonText, onClick }) => {
  if (!ButtonText) return null;

  return (
    <button
      onClick={onClick}
      className="rounded-full bg-gradient-to-r from-[#FF6700] to-[#FE8E0C] px-3 py-[11px] text-xs font-medium text-white uppercase md:w-full md:px-0 md:text-sm"
    >
      <div className="flex items-center justify-center gap-1">
        <span>{ButtonText}</span>
        <div className="flex">
          <i
            className="icomoon animated-button text-xs before:content-['\e911']"
            style={{ animationDelay: "0s" }}
          />
          <i
            className="icomoon animated-button text-xs before:content-['\e911']"
            style={{ animationDelay: "0.2s" }}
          />
          <i
            className="icomoon animated-button text-xs before:content-['\e911']"
            style={{ animationDelay: "0.4s" }}
          />
        </div>
      </div>
    </button>
  );
};

export default InvestButton;
